import React, { PropsWithChildren } from 'react'
import { ModalContent } from '@babylon/medkit'

interface Props {
  title?: string
  content?: string
}

const GenericModal = ({
  title,
  content,
  children,
}: PropsWithChildren<Props>) => (
  <ModalContent title={title}>
    {content && (
      <div
        data-testid="genericModalContent"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )}
    <div data-testid="genericModalChildren">{children}</div>
  </ModalContent>
)

export default GenericModal
